export default "__VITE_ASSET__1688c929__"